//Modules
import React, { Fragment, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { OfficeBuildingIcon, CheckIcon, XIcon } from "@heroicons/react/outline";

export default function LegacyPrompt({ user }) {
  const [userMatch, setUserMatch] = useState(null);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <Link href="/">
            <div className="flex justify-center cursor-pointer">
              <Image
                src="/logo/wave-distro-logo.png"
                alt="Wave Distribution Logo"
                layout="intrinsic"
                width={230}
                height={66}
              />
            </div>
          </Link>
        </div>

        <p className="mt-4 mb-4 text-center ">
          We found the following user in our database:
        </p>
      </div>

      <div className="flex items-center mt-4 pt-3 pb-3 pr-24 pl-24 rounded border-gray-200 border-2 border-solid">
        <div className="hidden h-16 w-16 rounded-full sm:inline-flex items-center justify-center bg-primary">
          <span className="sr-only">User Initials</span>
          <span className="font-medium leading-none text-white text-2xl">
            {user.FirstName.charAt(0).toUpperCase()}
            {user.LastName.charAt(0).toUpperCase()}
          </span>
        </div>
        <div>
          <div className="flex items-center">
            <div className="sm:hidden h-8 w-8 rounded-full inline-flex items-center justify-center bg-primary">
              <span className="sr-only">User Initials</span>
              <span className="font-medium leading-none text-white text-base sm:text-xl">
                {/* {data?.contact.FirstName.charAt(0)}
                              {data?.contact.LastName.charAt(0)} */}
              </span>
            </div>
            <h1 className="ml-3 sm:text-2xl text-xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate">
              {user.FirstName}
            </h1>
          </div>
          <dl className="mt-6 flex flex-col sm:ml-3 sm:mt-1 sm:flex-row sm:flex-wrap">
            <dt className="sr-only">Company</dt>
            <dd className="flex items-center text-sm text-gray-500 font-medium capitalize sm:mr-6">
              <OfficeBuildingIcon
                className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              {user.CompanyName || "Individual"}
            </dd>
          </dl>
        </div>
      </div>

      <div className="max-w-md w-full space-y-8">
        {userMatch === null ? (
          <p className="mt-4 mb-4 text-center ">Is this you?</p>
        ) : null}
        <div className="flex w-full justify-around items-center">
          {userMatch === null ? (
            <Fragment>
              <button
                type="button"
                onClick={() => setUserMatch(true)}
                className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Yes, this is me
                <CheckIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
              </button>
              <button
                type="button"
                onClick={() => setUserMatch(false)}
                className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                No, this is not me
                <XIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
              </button>
            </Fragment>
          ) : userMatch === true ? (
            <Fragment>
              <div className="flex flex-col">
                <div className="mt-4 mb-4 text-center">
                  Hi {user.FirstName}, Thanks for using our webstore! <br />
                  Click the link below to migrate your account to our webstore.
                  <p className="mt-4 text-center text-sm text-gray-600">
                    <Link href="/legacy">
                      <span className="font-medium text-primaryDark hover:text-primary">
                        Please click here to migrate your account
                      </span>
                    </Link>
                  </p>
                </div>
              </div>
            </Fragment>
          ) : userMatch === false ? (
            <div className="flex flex-col">
              <div className="mt-4 mb-4 text-center">
                Your email is currently in use. <br /> Please get in touch with
                us and we'll help you as fast as we can.
              </div>
              <p className="mt-4 text-center text-sm text-gray-600">
                <Link href="/contact">
                  <span className="font-medium text-primaryDark hover:text-primary">
                    Please click here to get in touch
                  </span>
                </Link>
              </p>
              <p className="mt-4 text-center text-sm text-gray-600">
                <Link href="/contact">
                  <span className="font-medium text-primaryDark hover:text-primary">
                    Click here to go back to the website
                  </span>
                </Link>
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
